export const getAuth = () =>
  JSON.parse(localStorage.getItem('access_token') || '{}')

export const storeAuth = auth =>
  localStorage.setItem('access_token', JSON.stringify(auth))

export const removeAuth = () => localStorage.removeItem('access_token')

export const isAuthenticated = () => getAuth().token != null
